import { render, staticRenderFns } from "./OfficeShipped.vue?vue&type=template&id=1314e573&"
import script from "./OfficeShipped.vue?vue&type=script&lang=js&"
export * from "./OfficeShipped.vue?vue&type=script&lang=js&"
import style0 from "./OfficeShipped.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports